import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ReactQueryDevtools } from 'react-query/devtools';
import { GlobalStyles } from '../GlobalStyles';
import { AuthProvider } from './Auth';
import { ReactQueryProvider } from './QueryClient';
import { MuiThemeProvider } from './MuiTheme';
interface Props {
  children: React.ReactNode;
}

function AppProviders({ children }: Props) {
  return (
    <ReactQueryProvider>
      <Router>
        <MuiThemeProvider>
          <GlobalStyles />
          <Toaster />
          <AuthProvider>{children}</AuthProvider>
          <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
        </MuiThemeProvider>
      </Router>
    </ReactQueryProvider>
  );
}

export { AppProviders };
